import {makeCall} from 'services/Api';

/**
 * Make a Request to Passport
 * 
 * @param  {String} action
 * @param  {Object} payload
 * @param  {boolean} [showRunning]
 *
 * @return {Promise}
 */
export const endpoint = (action, payload, showRunning = true) => makeCall(
    '/api/passport/'+(`${action}`),
    payload,
    showRunning
);

/**
 * User Endpoints:
 *     - Authenticate
 */
export default {
    /**
     * Authenticate a User with the Payload of Data.
     *
     * @param  {object} data
     *
     * @return {Promise}
     */
    login(data) {
        return endpoint('login', data);
    },

    /**
     * Logout a User
     *
     * @return {Promise}
     */
    logout() {
        return endpoint('logout');
    },

    /**
     * Check a users logged in status
     *
     * @return {Promise}
     */
    authenticate(data) {
        return endpoint('authenticate', data);
    },

    /**
     * Check a users logged in status
     *
     * @return {Promise}
     */
    heartbeat() {
        return endpoint('heartbeat', null, false);
    }
};



// WEBPACK FOOTER //
// ./src/services/api/users.js